import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("jt_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatErr(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return JSON.stringify(d);
}

export function inr(n) {
  return "₹" + Number(n || 0).toLocaleString("en-IN");
}
